export default "__VITE_ASSET__29_4OUJ9__"